import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { BASE_URL, HTTP_STATUS, ACCOUNT_TYPES_OPPOS } from '../../utils/constant'
import { newAxiosInstance } from '../../../axios'
import UrlBuilder from 'app/utils/UrlBuilder'
import { generateDownloadFileName, downloadFile } from 'app/utils/utils';

const initialState = {    
    Asset: [],
    Liability: [],
    Equity: [],
    Revenue: [],
    Expense: [],
    incomeStatment: [],
    cashInHand: null, 
    trailBalance: null,
    dayends: [],
    glEntries: [],
    dayendDate: null,
    ledgers: [],
    report: null,
    status: HTTP_STATUS.IDLE,
    dayendsStatus: HTTP_STATUS.IDLE,
    deleteStatus: HTTP_STATUS.IDLE,
    createStatus: HTTP_STATUS.IDLE,
    reportStatus: HTTP_STATUS.IDLE
}

export const fetchAccounts = createAsyncThunk('account/get-accounts', async (data = null, { rejectWithValue }) => {
    try {
        let url = new UrlBuilder().searchQuery(data).filter(data, 'acc_type').getUrl();
        const response = await newAxiosInstance.get(BASE_URL + '/api/Account' + url ) 
        return { data: response.data, type: data?.acc_type }
    }catch(err){
        if(!err.response) throw err;
        return rejectWithValue(err.response.data)
    }
})

export const fetchLedger = createAsyncThunk('account/get-ledger', async (data, { rejectWithValue }) => {
    try {  
        let url = new UrlBuilder().searchQuery(data).filter(data, 'fileType').filter(data, 'stDate').filter(data, 'enDate').filter(data, 'accId').getUrl();
        let responseType = data?.fileType && parseInt(data.fileType) > 0 ? 'blob' : 'text';
        const response = await newAxiosInstance.get(BASE_URL + `/api/Account/get-ledger-log${url}`,{ responseType })
        if(responseType === 'text') return response.data
        let filename = generateDownloadFileName(response.headers['content-disposition']);
        downloadFile(response.data, filename);       
        return null
    }catch(err){
        if(!err.response) throw err;
        return rejectWithValue(err.response.data)
    }    
})

export const fetchJournal = createAsyncThunk('account/get-journal', async (data, { rejectWithValue }) => {
    try {  
        let url = new UrlBuilder().searchQuery(data).filter(data, 'fileType').filter(data, 'stDate').filter(data, 'enDate').getUrl();
        let responseType = data?.fileType && parseInt(data.fileType) > 0 ? 'blob' : 'text';
        const response = await newAxiosInstance.get(BASE_URL + `/api/Account/journal-entry-log${url}`,{ responseType })
        if(responseType === 'text') return response.data
        let filename = generateDownloadFileName(response.headers['content-disposition']);
        downloadFile(response.data, filename);       
        return null
    }catch(err){
        if(!err.response) throw err;
        return rejectWithValue(err.response.data)
    }    
})

export const fetchIncomeStatmentAccounts = createAsyncThunk('account/get-income-statement-accounts', async (data = null, { rejectWithValue }) => {
    try {
        let url = new UrlBuilder().searchQuery(data).filter(data, 'endDate').getUrl();
        const response = await newAxiosInstance.get(BASE_URL + '/api/Account/get-income-statment' + url ) 
        return response.data
    }catch(err){
        if(!err.response) throw err;
        return rejectWithValue(err.response.data)
    }
})

export const fetchDayends = createAsyncThunk('account/get-day-ends', async (data = null, { rejectWithValue }) => {
    try {
        let url = new UrlBuilder().searchQuery(data).filter(data, 'fromDate').filter(data, 'toDate').getUrl();
        const response = await newAxiosInstance.get(BASE_URL + '/api/Account/get-day-end' + url ) 
        return response.data
    }catch(err){
        if(!err.response) throw err;
        return rejectWithValue(err.response.data)
    }
})

export const fetchLedgerByAcount = createAsyncThunk('account/get-ledger-by-account', async (data = null, { rejectWithValue }) => {
    try {
        const response = await newAxiosInstance.get(BASE_URL + '/api/Account/get-past-ledger-balance/' + data ) 
        return response.data
    }catch(err){
        if(!err.response) throw err;
        return rejectWithValue(err.response.data)
    }
})

export const fetchDayendDate = createAsyncThunk('account/get-day-end-date', async (data = null, { rejectWithValue }) => {
    try {
        const response = await newAxiosInstance.get(BASE_URL + '/api/Account/get-day-end-date' ) 
        return response.data
    }catch(err){
        if(!err.response) throw err;
        return rejectWithValue(err.response.data)
    }
})

export const fetchJournalEntries = createAsyncThunk('account/get-journalEntries', async (data = null, { rejectWithValue }) => {
    try {
        let url = new UrlBuilder().filter(data, 'startDate').filter(data, 'endDate').filter(data, 'refId').getUrl();
        const response = await newAxiosInstance.get(BASE_URL + '/api/Account/get-journal-entries' + url ) 
        return response.data
    }catch(err){
        if(!err.response) throw err;
        return rejectWithValue(err.response.data)
    }
})

export const fetchCashInHand = createAsyncThunk('account/get-cash-in-hand', async (data = null, { rejectWithValue }) => {
    try {
        let url = new UrlBuilder().filter(data, 'fileType').filter(data, 'enDate').getUrl();
        let responseType = data?.fileType && parseInt(data.fileType) > 0 ? 'blob' : 'text';
        const response = await newAxiosInstance.get(BASE_URL + `/api/Account/cash-in-hand${url}`,{ responseType })
        if(responseType === 'text') return response.data
        let filename = generateDownloadFileName(response.headers['content-disposition']);
        downloadFile(response.data, filename);       
        return null
    }catch(err){
        if(!err.response) throw err;
        return rejectWithValue(err.response.data)
    }
})

export const fetchTrailBalance = createAsyncThunk('account/get-trail-balance', async (data = null, { rejectWithValue }) => {
    try {
        let url = new UrlBuilder().filter(data, 'fileType').filter(data, 'enDate').getUrl();
        let responseType = data?.fileType && parseInt(data.fileType) > 0 ? 'blob' : 'text';
        const response = await newAxiosInstance.get(BASE_URL + `/api/Account/trail-balance${url}`,{ responseType })
        if(responseType === 'text') return response.data
        let filename = generateDownloadFileName(response.headers['content-disposition']);
        downloadFile(response.data, filename);       
        return null
    }catch(err){
        if(!err.response) throw err;
        return rejectWithValue(err.response.data)
    }
})

export const createAccount = createAsyncThunk('accounts/create', async (postdata, { rejectWithValue }) => {
    try {
        const response = await newAxiosInstance.post(BASE_URL + '/api/Account', postdata)
        return response.data
    }catch(err){
        if(!err.response) throw err;
        return rejectWithValue(err.response)
    }
})

export const createGlEntry = createAsyncThunk('accounts/create-gl-entry', async (postdata, { rejectWithValue }) => {
    try {
        const response = await newAxiosInstance.post(BASE_URL + '/api/Account/create-gl-entry', postdata)
        return response.data
    }catch(err){
        if(!err.response) throw err;
        return rejectWithValue(err.response)
    }
})

export const updateAccount = createAsyncThunk('accounts/update', async (postdata, { rejectWithValue }) => {
    try {
        const response = await newAxiosInstance.put(BASE_URL + `/api/Account/${postdata.id}`, postdata)
        return response.data
    }catch(err){
        if(!err.response) throw err;
        return rejectWithValue(err.response)
    }
})

export const deleteAccount = createAsyncThunk('accounts/delete', async (id, { rejectWithValue }) => {
    try {
        const response = await newAxiosInstance.delete(BASE_URL + `/api/Account/${id}`)
        return response.data
    }catch(err){
        if(!err.response) throw err;
        return rejectWithValue(err.response)
    }
})

export const Account = createSlice({
    name: 'account',
    initialState,
    reducers: {
        resetState: (state, action) => {
            return initialState;
        },
        resetIncomeStatment: (state, action) => {
            state.incomeStatment = []
            return state;
        },
        setCashinHandDate: (state, action) => {
            state.dayendDate = {...state.dayendDate, dayendDate: action.payload}
        },
        flushDayends: (state, action) => {
            state.dayends = []
            return state;
        },
        flushLedgerByAccid: (state, action) => {
            state.ledgers = []
            return state;
        }
    },
    extraReducers(builder) {
        builder
            .addCase(fetchAccounts.pending, (state, action) => {
                state.status = HTTP_STATUS.LOADING
            })
            .addCase(fetchAccounts.fulfilled, (state, action) => {
                state.status = HTTP_STATUS.SUCCEEDED
                state[ACCOUNT_TYPES_OPPOS[action.payload.type]] = action.payload.data
            })
            .addCase(fetchAccounts.rejected, (state, action) => {
                state.status = HTTP_STATUS.FAILED
            })
            .addCase(fetchLedger.pending, (state, action) => {
                state.reportStatus = HTTP_STATUS.LOADING
            })
            .addCase(fetchLedger.fulfilled, (state, action) => {
                state.reportStatus = HTTP_STATUS.SUCCEEDED
                state.report = action.payload
            })
            .addCase(fetchLedger.rejected, (state, action) => {
                state.reportStatus = HTTP_STATUS.FAILED
            })
            .addCase(fetchJournal.pending, (state, action) => {
                state.reportStatus = HTTP_STATUS.LOADING
            })
            .addCase(fetchJournal.fulfilled, (state, action) => {
                state.reportStatus = HTTP_STATUS.SUCCEEDED
                state.report = action.payload
            })
            .addCase(fetchJournal.rejected, (state, action) => {
                state.reportStatus = HTTP_STATUS.FAILED
            })
            .addCase(fetchJournalEntries.pending, (state, action) => {
                state.status = HTTP_STATUS.LOADING
            })
            .addCase(fetchJournalEntries.fulfilled, (state, action) => {
                state.status = HTTP_STATUS.SUCCEEDED
                state.glEntries = action.payload
            })
            .addCase(fetchJournalEntries.rejected, (state, action) => {
                state.status = HTTP_STATUS.FAILED
            })
            .addCase(fetchIncomeStatmentAccounts.pending, (state, action) => {
                state.status = HTTP_STATUS.LOADING
            })
            .addCase(fetchIncomeStatmentAccounts.fulfilled, (state, action) => {
                state.status = HTTP_STATUS.SUCCEEDED
                state.incomeStatment = action.payload
            })
            .addCase(fetchIncomeStatmentAccounts.rejected, (state, action) => {
                state.status = HTTP_STATUS.FAILED
            })
            .addCase(deleteAccount.pending, (state, action) => {
                state.deleteStatus = HTTP_STATUS.LOADING
            })
            .addCase(deleteAccount.fulfilled, (state, action) => {
                state.deleteStatus = HTTP_STATUS.SUCCEEDED
            })
            .addCase(deleteAccount.rejected, (state, action) => {
                state.deleteStatus = HTTP_STATUS.FAILED
            })
            .addCase(createAccount.pending, (state, action) => {
                state.createStatus = HTTP_STATUS.LOADING
            })
            .addCase(createAccount.fulfilled, (state, action) => {
                state.createStatus = HTTP_STATUS.SUCCEEDED
            })
            .addCase(createAccount.rejected, (state, action) => {
                state.createStatus = HTTP_STATUS.FAILED
            })
            .addCase(createGlEntry.pending, (state, action) => {
                state.createStatus = HTTP_STATUS.LOADING
            })
            .addCase(createGlEntry.fulfilled, (state, action) => {
                state.createStatus = HTTP_STATUS.SUCCEEDED
            })
            .addCase(createGlEntry.rejected, (state, action) => {
                state.createStatus = HTTP_STATUS.FAILED
            })
            .addCase(fetchCashInHand.pending, (state, action) => {
                state.status = HTTP_STATUS.LOADING
            })
            .addCase(fetchCashInHand.fulfilled, (state, action) => {
                state.status = HTTP_STATUS.SUCCEEDED
                state.cashInHand = action.payload
            })
            .addCase(fetchCashInHand.rejected, (state, action) => {
                state.status = HTTP_STATUS.FAILED
            })
            .addCase(fetchTrailBalance.pending, (state, action) => {
                state.status = HTTP_STATUS.LOADING
            })
            .addCase(fetchTrailBalance.fulfilled, (state, action) => {
                state.status = HTTP_STATUS.SUCCEEDED
                state.trailBalance = action.payload
            })
            .addCase(fetchTrailBalance.rejected, (state, action) => {
                state.status = HTTP_STATUS.FAILED
            })
            .addCase(fetchDayends.pending, (state, action) => {
                state.dayendsStatus = HTTP_STATUS.LOADING
            })
            .addCase(fetchDayends.fulfilled, (state, action) => {
                state.dayendsStatus = HTTP_STATUS.SUCCEEDED
                state.dayends = action.payload
            })
            .addCase(fetchDayends.rejected, (state, action) => {
                state.dayendsStatus = HTTP_STATUS.FAILED
            })
            .addCase(fetchLedgerByAcount.pending, (state, action) => {
                state.dayendsStatus = HTTP_STATUS.LOADING
            })
            .addCase(fetchLedgerByAcount.fulfilled, (state, action) => {
                state.dayendsStatus = HTTP_STATUS.SUCCEEDED
                state.ledgers = action.payload
            })
            .addCase(fetchLedgerByAcount.rejected, (state, action) => {
                state.dayendsStatus = HTTP_STATUS.FAILED
            })
            .addCase(fetchDayendDate.fulfilled, (state, action) => {
                state.dayendDate = {...action.payload, cashInHandDate: action.payload?.dayendDate}
            })
    }
})

export const getAccounts = (state) => state.account;
export const getAssetAccounts = (state) => state.account.Asset;
export const getLiabilityAccounts = (state) => state.account.Liability;
export const getEquityAccounts = (state) => state.account.Equity;
export const getRevenueAccounts = (state) => state.account.Revenue;
export const getExpenseAccounts = (state) => state.account.Expense;
export const getDeletestatus = (state) => state.account.deleteStatus;
export const getCreateStatus = (state) => state.account.createStatus;
export const getStatus = (state) => state.account.status
export const getDayendsStatus = (state) => state.account.dayendsStatus
export const getIncomeStatement = (state) => state.account.incomeStatment;
export const getCashInHand = (state) => state.account.cashInHand;
export const getTrailBalance = (state) => state.account.trailBalance;
export const getDayEnds = (state) => state.account.dayends;
export const getDayEndDate = (state) => state.account.dayendDate;
export const getGLEntries = (state) => state.account.glEntries;
export const getLedgerByAccid = (state) => state.account.ledgers;
export const getReport = (state) => state.account.report;
export const getReportStatus = (state) => state.account.reportStatus;

export const accountActions = Account.actions

export default Account.reducer